<template>
  <div>
    <el-dialog
      ref="addDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h720_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddForm"
          :model="dialogAddForm"
          :rules="dialogAddFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="资产来源">
                    <el-radio-group
                      v-model="dialogAddForm.source"
                      @change="handleSourceChange"
                    >
                      <el-radio :label="1">
                        制作物料
                      </el-radio>
                      <el-radio :label="2">
                        其他
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddForm.source === 1"
                  :span="12"
                >
                  <el-form-item
                    label="资产名称"
                    prop="materialsId"
                  >
                    <el-select
                      v-model="dialogAddForm.materialsId"
                      filterable
                      clearable
                      placeholder="请选择需求物料"
                      style="width:100%"
                      @change="materialsChangeFun"
                    >
                      <el-option
                        v-for="item in materialsOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                        <span style="float: left">{{ item.label }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.typeValue }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  v-else
                  :span="12"
                >
                  <el-form-item
                    label="资产名称"
                    prop="name"
                  >
                    <el-input
                      v-model="dialogAddForm.name"
                      maxlength="128"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="计量单位"
                    prop="unit"
                  >
                    <el-input
                      v-model="dialogAddForm.unit"
                      maxlength="32"
                      :disabled="dialogAddForm.source === 1"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="规格配置">
                    <el-input
                      v-model="dialogAddForm.configSpec"
                      type="textarea"
                      placeholder="请输入固定资产的规格或配置信息"
                      show-word-limit
                      maxlength="256"
                      rows="3"
                      style="margin-top: -8px;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              管理人员清单
              <el-button
                plain
                size="mini"
                icon="el-icon-circle-plus-outline"
                style="float:right; margin-top:0.1em; margin-right:15px;"
                @click="addAssetManagerFun"
              >
                添加管理人员
              </el-button>
            </h3>
            <div
              class="modal-row-box"
              style="height: 220px;"
            >
              <el-table
                :data="dialogAddForm.fixedAssetManagerData"
                style="width: 100%; display: inline-block;"
                :header-cell-style="{background:'#0076ff'}"
                border
                max-height="210"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  width="60"
                  align="center"
                />
                <el-table-column
                  label="管理人员"
                  header-align="center"
                >
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'fixedAssetManagerData.' + scope.$index + '.managerId'"
                      :rules="dialogAddFormRules.managerId"
                    >
                      <el-select
                        v-model="scope.row.managerId"
                        filterable
                        clearable
                        placeholder="请选择管理人员"
                        style="width:100%"
                        @change="managerChangeFun(scope.row, $event)"
                      >
                        <el-option
                          v-for="item in userOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="manageNumber"
                  label="管理数量"
                  align="center"
                  width="300"
                >
                  <template slot-scope="scope">
                    <el-form-item>
                      <el-input
                        v-model="scope.row.manageNumber"
                        @input="(val) => {limitPositiveNumber(val, scope.row, 'manageNumber')}"
                        @blur="setNumberValueDefaultZero($event, scope.row, 'manageNumber', 2);"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="lentNumber"
                  label="借出数量"
                  align="center"
                  width="150"
                />
                <el-table-column
                  prop="damageNumber"
                  label="损坏遗失数量"
                  align="center"
                  width="150"
                />
                <el-table-column
                  label="操作"
                  width="60"
                  align="center"
                >
                  <template slot-scope="scope">
                    <i
                      class="el-icon-delete"
                      style="color: red; font-size: 16px;"
                      @click="handleDeleteManager(scope.$index)"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddForm.remark"
                      type="textarea"
                      placeholder="备注"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 物料API
import { listMaterialsApi } from '@/api/v2/materials';
// 数据请求
import { saveFixedAssetApi } from '@/api/fixedAsset'
import { loadUserSelectDataByUserRegionIdsApi } from '@/api/user'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogAddForm: {},
      dialogAddFormRules: {
        materialsId: [{ required: true, message: '请选择固定资产物料', trigger: 'change' }],
        managerId: [{ required: true, message: '请选择固定资产管理人员', trigger: 'change' }],
        name: [{ required: true, message: '请输入固定资产名称', trigger: 'blur' }, { max: 128, message: '固定资产名称最多允许输入 128 个字符', trigger: 'blur' }],
        unit: [{ required: false, message: '请输入固定资产计量单位', trigger: 'blur' }, { max: 32, message: '固定资产计量单位最多允许输入 32 个字符', trigger: 'blur' }],
        configSpec: [{ max: 256, message: '规格配置最多允许输入 256 个字符', trigger: 'blur' }],
        remark: [{ max: 255, message: '备注最多允许输入 255 个字符', trigger: 'blur' }]
      },
      materialsOptions: [],
      userOptions: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this
        _this.loading = true
        _this.loadingText = '努力加载数据中，请耐心等待'
        _this.operateButtonDisable = false

        _this.materialsOptions = []
        _this.userOptions = []
        _this.dialogAddForm = {
          source: 1,
          materialsId: '',
          name: '',
          unit: '',
          configSpec: '',
          remark: '',
          fixedAssetManagerData: [],
          fixedAssetManagerDataJson: '' // 管理人员信息JSON字符串
        }
        // 获取物料下拉选择项
        _this.initMaterialsData()
        // 获取管理人员选项数据
        _this.initManagerSelectData()

        _this.$nextTick(() => {
          _this.$refs.dialogAddForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 固定资产来源变更
    handleSourceChange (val) {
      let _this = this;
      if (val === 2) {
        _this.dialogAddFormRules.unit[0].required = true;
      } else {
        _this.dialogAddFormRules.unit[0].required = false;
      }
      _this.$refs.dialogAddForm.clearValidate();
    },
    // 获取物料下拉框数据
    initMaterialsData () {
      let _this = this
      listMaterialsApi({ sortIds: '1, 2, 5', orderSort: 'sort_id, brand_id asc' }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.materialsOptions.push({
            label: item.name, value: item.id, unitName: item.minimumUnit, unitId: 0, specification: item.specification, typeValue: item.sortName + ' - ' + item.brandName
          })
        })
        _this.loading = false
      })
    },
    // 选择物料回调
    materialsChangeFun (val) {
      let _this = this
      let selectedItem = {}
      if (val) {
        selectedItem = _this.materialsOptions.find(item => {
          return item.value === val
        })
      }
      _this.dialogAddForm.name = selectedItem.label || ''
      _this.dialogAddForm.unit = selectedItem.unitName || ''
      _this.dialogAddForm.configSpec = selectedItem.specification || ''
    },
    // 初始管理人员选项数据
    initManagerSelectData () {
      let _this = this
      loadUserSelectDataByUserRegionIdsApi().then(response => {
        console.log(response.data)
        response.data.forEach(item => {
          _this.userOptions.push({ label: item.name, value: item.id })
        })
      })
    },
    // 管理人员选择回调
    managerChangeFun (row, val) {
      let _this = this
      let selectedItem = {}
      if (val) {
        selectedItem = _this.userOptions.find(item => {
          return item.value === val
        })
      }
      row.managerName = selectedItem.label || ''
    },
    // 增加管理人员
    addAssetManagerFun () {
      this.dialogAddForm.fixedAssetManagerData.push({ managerId: '', managerName: '', manageNumber: 0, lentNumber: 0, damageNumber: 0 })
    },
    // 删除管理人员
    handleDeleteManager (index) {
      this.dialogAddForm.fixedAssetManagerData.splice(index, 1)
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      let _this = this
      _this.$refs.dialogAddForm.validate(valid => {
        if (valid) {
          this.$confirm('是否确定保存固定资产', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            // 验证管理人员是否存在重复的
            let managerCountMap = new Map()
            let managerDataMap = new Map()
            _this.dialogAddForm.fixedAssetManagerData.forEach(item => {
              let managerId = item.managerId
              let existCount = 1
              if (managerCountMap.get(managerId)) {
                existCount = existCount + managerCountMap.get(managerId)
              }
              managerCountMap.set(managerId, existCount)
              managerDataMap.set(managerId, item.managerName)
            })
            for (var [key, value] of managerCountMap) {
              if (value > 1) {
                _this.$message({ message: '管理人员[' + managerDataMap.get(key) + ']重复存在，请删除重复项', type: 'warning' })
                return false
              }
            }
            _this.operateButtonDisable = true
            _this.loading = true
            _this.loadingText = '正在处理数据中，请耐心等待'

            if (_this.dialogAddForm.source === 2) {
              _this.dialogAddForm.materialsId = 0;
            }
            _this.dialogAddForm.fixedAssetManagerDataJson = JSON.stringify(_this.dialogAddForm.fixedAssetManagerData)
            saveFixedAssetApi(_this.dialogAddForm).then(res => {
              _this.$message({ message: res.message, type: 'success' })
              _this.reloadData()
              _this.modalClose()
            }).catch(() => {
              _this.loading = false
              _this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
  .cell {
    line-height: 16px;
  }
}

::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}

.source-textarea {
  ::v-deep .el-textarea__inner {
    margin-top: 0px;
    font-size: 12px;
  }
}
</style>
